import React, {
  LegacyRef,
  MutableRefObject,
  useEffect,
  useRef,
  useState,
} from "react";
import { makePost } from "../../utils/fetchUtils";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { LOGIN, SEND_OTP, VALIDATE_OTP_LOGIN } from "../../utils/constants";
import { setTimeout } from "timers/promises";
import { getRoles } from "@testing-library/react";
import { ErrorObj } from "../../utils/types";
// import Header from "../../components/Header";
import nclude from "../../assets/nclude.svg";
import sticker1 from "../../assets/sticker1.svg";
import curve1 from "../../assets/curve.svg";
import woman1 from "../../assets/woman1.png";
import greaterThan from "../../assets/greaterthan.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import OtpInput from "../../components/otp-login";
import useWindowWidth from "../../utils/windowWidth";

const Login = () => {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);
  const location = useLocation();

  const labelRef = useRef<HTMLLabelElement>(null);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [choice, setChoice] = useState("phone"); // "phone" | "email"
  const [error, setError] = useState<ErrorObj>({
    email: "",
    password: "",
    phone: "",
    system: "",
  });

  useEffect(() => {
    if (localStorage.getItem("token")) {
      navigate("/");
    }

    document.title = "Login - Nclude Portal";
  }, []);

  const handleOtpSend = async () => {
    handleShow();
    setOtp("");
    try {
      setError({
        email: "",
        password: "",
        phone: "",
        system: "",
      });
      if (phoneNumber.length !== 10) {
        setError({
          ...error,
          phone: "Enter valid 10 Digit Number",
        });
        return;
      }
      if (!/^\d*$/.test(phoneNumber)) {
        setError({
          ...error,
          phone: "Please enter a valid phone number",
        });
        return;
      }

      const body = {
        phoneNumber: phoneNumber,
        userType: "user",
      };
      const response = await makePost(SEND_OTP, JSON.stringify(body));
      console.log(response);
      setOtpSent(true);
    } catch (error: any) {
      console.log(error.message);
    }
  };
  

  const handleOtpLogin = async () => {
    setError({
      email: "",
      password: "",
      phone: "",
      system: "",
    });
    setOtpSent(false);
    try {
      const body = {
        phoneNumber,
        otp,
      };
      const response = await makePost(VALIDATE_OTP_LOGIN, JSON.stringify(body));
      // console.log(response);
      if (response.success === true) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("resume", response.hasUserInfo);
        localStorage.setItem("scope", response.scope);
        localStorage.setItem("userId", response.userId);
        // localStorage.setItem("userPhoneNumber", response.user.phoneNumber);
        navigate("/");
      }
      setError(response.message);
    } catch (error: any) {
      if (error.response && error.response.data) {
        setError({
          ...error,
          system: error.response.data.message,
        });
      }
      console.log("error while logging in : ", error);
    }
  };

  const handleEmailLogin = async () => {
    setError({
      email: "",
      password: "",
      phone: "",
      system: "",
    });
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setError({
        ...error,
        email: "Please enter a valid email address",
      });
      return;
    }
    try {
      if (email === "") {
        setError({
          ...error,
          email: "Please Fill the required fields",
        });
        return;
      }
      if (password === "") {
        setError({
          ...error,
          password: "Please Fill the required fields",
        });
        return;
      }

      const body = {
        email: email,
        password: password,
      };

      const response = await makePost(LOGIN, JSON.stringify(body));
      // console.log(response);
      if (response.success === true) {
        localStorage.setItem("token", response.token);
        localStorage.setItem("resume", response.hasUserInfo);
        localStorage.setItem("scope", response.scope);
        localStorage.setItem("userId", response.userId);
        // localStorage.setItem("userPhoneNumber", response.user.phoneNumber);
        navigate("/");
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        setError({
          ...error,
          system: error.response.data.message,
        });
      }
      console.log("error while logging in : ", error);
    }
  };

  const handleLogin = async () => {
    if (choice === "email") {
      handleEmailLogin();
    } else {
      handleOtpLogin();
    }
  };

  const updateOtp = (userOtp: any) => {
    console.log(userOtp);
    setOtp(userOtp);
    // handleLogin();
  };

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (labelRef.current) {
      labelRef.current.focus();
    }
    // handleShow();
  }, [otpSent]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  return (
    <div className="auth-page flex items-center login-form" style={{ minHeight: isMobile?'50vh':'100vh' }} role="main">
      <div className="logo-container">
        <div className="flex justify-center items-center h-screen w-full">
          <div className="flex flex-col items-start">
            <img src={nclude} alt="Nclude logo" className="logo mb-3" />
            <div className="flex flex-col items-start text-container">
              <img src={sticker1} alt="" aria-hidden="true" className="sticker1 mb-2" />
              <img src={curve1} alt="" aria-hidden="true" className="curve1 mb-4" />
                <h3 className="text-left font-normal">
                Resources <br />
                and opportunities for <span className="font-bold tracking-normal text-white">People with Disabilities</span>
                </h3>
            </div>
          </div>
        </div>
      </div>
      <div className="auth-form-container flex flex-col items-center">
        <div className="auth-form">
          <h1
            className="mt-12 mb-3 text-[2rem]"
            ref={mainRef}
            tabIndex={-1}
            style={{ fontWeight: 600, lineHeight: "2.375rem" }}
          >
            Welcome to Nclude Portal
          </h1>
          <h2
            className="text-[2rem]"
            style={{ color: "#787486", fontWeight: 500, fontSize: "1rem" }}
          >
            Login to your account
          </h2>
          <div className="flex flex-col">
            {error.system && (
              <p className="text-center mt-6 text-[#FF0000]" role="alert">
                {error.system}
              </p>
            )}
            {choice === "email" && (
              <>
                {/* <label htmlFor="email" className="mt-12">
                  Enter Email Address
                </label> */}
                <label htmlFor="email" className="mt-12 sr-only">
                  Enter Email Address
                </label>
                <div style={{ position: "relative" }}>
                  <label className="border-label">Email Address</label>
                </div>
                <input
                  className="w-[100%] h-[5rem] px-4 mt-12 input input-email"
                  placeholder="Enter E-mail Address"
                  id="email"
                  type="email"
                  value={email}
                  required
                  onChange={(e) => {
                    const value = e.target.value;
                    setEmail(value);
                    setError({
                      email: "",
                      password: "",
                      phone: "",
                      system: "",
                    });
                  }}
                />
                {error.email && (
                  <p
                    className="text-center mt-2 mb-0 text-[#FF0000]"
                    role="alert"
                  >
                    {error.email}
                  </p>
                )}
              </>
            )}

            {choice === "email" && (
              <>
                {/* <label htmlFor="password" className="mt-12">
                  Enter Password
                </label> */}
                <label htmlFor="password" className="mt-12 sr-only">
                Enter Password
                </label>
                <div style={{ position: "relative" }}>
                  <label className="border-label">Password</label>
                </div>
                <div style={{ position: "relative" }}>
                  <input
                    className="w-[100%] h-[5rem] px-4 mt-12 input input-password"
                    id="password"
                    type={showPassword ? "text" : "password"}
                    placeholder="Password (8+ characters)"
                    value={password}
                    required
                    onChange={(e) => {
                      setPassword(e.target.value);
                    }}
                  />
                  <button
                    type="button"
                    onClick={() => setShowPassword(!showPassword)}
                    aria-label={showPassword ? "Hide password" : "Show password"}
                    style={{
                      position: "absolute",
                      right: "1.25rem",
                      top: isMobile ? "50%" : "calc(50% + 1.5rem)",
                      transform: "translateY(-50%)",
                      background: "none",
                      border: "none",
                      cursor: "pointer",
                      color: "#6b7280",
                      padding: "0.25rem",
                      zIndex: 10,
                    }}
                  >
                    {showPassword ? (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M13.875 18.825A10.05 10.05 0 0112 19c-4.478 0-8.268-2.943-9.543-7a9.97 9.97 0 011.563-3.029m5.858-5.908a10.048 10.048 0 014.122-.963c4.478 0 8.268 2.943 9.542 7a10.025 10.025 0 01-4.132 5.411m0 0L21 21M3 3l18 18"
                        />
                      </svg>
                    ) : (
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke="currentColor"
                        strokeWidth="2"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
                        />
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
                        />
                      </svg>
                    )}
                  </button>
                </div>
                {error.password && (
                  <p
                    className="text-center mt-2 mb-0 text-[#FF0000]"
                    role="alert"
                  >
                    {error.password}
                  </p>
                )}
                <div className="text-right mt-2">
                  <Link
                    to="/forgot-password"
                    className="text-[#5030E5] hover:underline"
                    style={{ fontSize: "0.875rem", fontWeight: 500 }}
                  >
                    Forgot Password?
                  </Link>
                </div>
              </>
            )}

            {choice === "phone" && (
              <>
                <label htmlFor="phone" className="mt-12 sr-only">
                  Enter Phone Number
                </label>
                <div style={{ position: "relative" }}>
                  <label className="border-label">Mobile number</label>
                </div>
                <input
                  className="w-[100%] h-[5rem] px-4 mt-12 input input-phone"
                  id="phone"
                  type="tel"
                  pattern="[0-9]{10}"
                  placeholder="XXXXXXXXXX"
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d*$/.test(value)) {
                      setPhoneNumber(value);
                      setError({
                        email: "",
                        password: "",
                        phone: "",
                        system: "",
                      });
                    } else {
                      setError({
                        ...error,
                        phone: "Please enter a valid phone number",
                      });
                      setPhoneNumber(value);
                    }
                  }}
                  // readOnly={otpSent}
                />
                {error.phone && (
                  <p
                    className="text-center mt-2 mb-0 text-[#FF0000]"
                    role="alert"
                  >
                    {error.phone}
                  </p>
                )}
                {/* {error && <p className='text-center mt-6 text-[#FF0000]'>{error}</p>} */}
              </>
            )}

            {choice === "phone" && (
              <button
                className="mt-12 bg-[#4f00ec] w-[11.25rem] h-[3.875rem] rounded submit-button"
                onClick={handleOtpSend}
              >
                Send OTP
                <img src={greaterThan} alt="" aria-hidden="true" />
              </button>
            )}

            {/* {choice === "phone" && otpSent && (
              <>
                <label
                  htmlFor="email"
                  className="mt-12"
                  ref={labelRef}
                  tabIndex={-1}
                >
                  Enter OTP
                </label>
                <input
                  className="text-black w-[500px] h-[55px] rounded px-4"
                  id="otp"
                  type="text"
                  placeholder="verification OTP"
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                />
              </>
            )} */}
            {choice === "email" && (
              <button
                className="mt-12 bg-[#4f00ec] w-[11.25rem] h-[3.875rem] rounded submit-button"
                onClick={handleLogin}
              >
                {`Login`}
                <img src={greaterThan} alt="" aria-hidden="true" />
              </button>
            )}
            <Link
              to="/login"
              className="mt-10 text-right text-[#5030E5]"
              role="link"
              style={{ fontSize: "1rem", fontWeight: 500 }}
              onClick={() => {
                choice === "phone" ? setChoice("email") : setChoice("phone");
              }}
            >
              {choice === "phone"
                ? `Login Via Email Instead`
                : `Login Via Phone`}
            </Link>
            <h2
              style={{ fontSize: "1rem", fontWeight: 500 }}
              className="mt-2 text-right"
            >
              New to Nclude?{" "}
              <Link to="/signup" className="text-[#5030E5]" role="link" aria-label="Register Here (opens in a new window)" style={{textDecoration:"underline"}}>
                Register Here
              </Link>
            </h2>
            <div className="mt-6 text-center">
              <p style={{ fontSize: "0.875rem", marginBottom: "0.5rem" }}>
                Available on IVR: <span style={{ fontWeight: 500 }}>+91-8035737222</span>
              </p>
              {/* <p style={{ fontSize: "0.875rem", color: "red" }}>
                WhatsApp service is temporarily down as we switch service providers.
              </p> */}
            </div>

            {/* <p className='text-center mt-6 text-[#FF0000]'>{error}</p> */}
          </div>
        </div>
      </div>

      {(
        <Modal
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
          id="otp-modal"
        >
          <Modal.Header closeButton style={{ paddingBottom: 0 }}></Modal.Header>
          <Modal.Body className="modal-body">
            <div className="modal-title">
              <Modal.Title>OTP Verification</Modal.Title>
            </div>
            <p role="alert">
              We’ve sent a verification OTP to your mobile number - XXXX XXX XXX
            </p>
            <div className="otp-input-container">
              <OtpInput length={4} updateOtp={updateOtp} />
            </div>
            <Button variant="primary" onClick={handleLogin} className="button">
              Validate OTP
              <img src={greaterThan} alt="" aria-hidden="true" />
            </Button>
          </Modal.Body>
        </Modal>
      )}
    </div>
  );
};

export default Login;
